import React from 'react';

type Props = {
  message?: string;
};

export const Error = ({ message = 'Something went wrong!' }: Props) => (
  <main>{message}</main>
);
